// extracted by mini-css-extract-plugin
module.exports = {"scanner":"LoadingSpinner_scanner__1aRN1","loadingSpinner":"LoadingSpinner_loadingSpinner__Dm3t3"};